<template>
	<div v-if="exibir">
		<modal-formulario-assinatura-digital-generico
			id="modalFormularioAssinaturaDigital"
			v-if="exibirModalFormulario"
			:certificados="certificados"
			:titulo-documento="tituloDocumento"
			:exibir="exibirModalFormulario"
			:nome-botao-confirmar="nomeBotaoConfirmar"
			@fechar-modal="fecharModalFormulario"
			@assinar-digitalmente="assinarDigitalmente"
			@fechar-modal-pai-avo="fechar"
		></modal-formulario-assinatura-digital-generico>

		<modal-confirmacao
			id="modalConfirmacaoAssinaturaDigital"
			:exibir="exibirModalConfirmacao"
			:mensagem="mensagem"
			@fechar-modal="fecharModalConfirmacao"
			@confirmar="confirmarModalExtensaoNaoInstalada"
			:subtituloModal="subtitulo"
			:tituloModal="titulo"
		></modal-confirmacao>
	</div>
</template>
<script>
import { actionTypes, mutationTypes } from '@/core/constants'
import { AzDigitalSignature } from '@azinformatica/loki'
import { LoadingScreen } from '@/core/utils'
// eslint-disable-next-line vue/max-len
import ModalFormularioAssinaturaDigitalGenerico from '@/views/components/documentos/controle-documentos/assinatura/digital/modal-formulario/ModalFormularioAssinaturaDigitalGenerico.vue'
import route from '@/views/mixins/route'
import ModalConfirmacao from '@/views/components/ModalConfirmacao.vue'

export default {
	name: 'modal-assinatura-digital-generico',
	components: { ModalConfirmacao, ModalFormularioAssinaturaDigitalGenerico },
	mixins: [route],
	props: {
		exibir: {
			type: Boolean,
			required: true,
		},
		titulo: {
			type: String,
			required: true,
		},
		subtitulo: {
			type: String,
			required: true,
		},
		mensagem: {
			type: String,
			required: true,
		},
		nomeBotaoConfirmar: {
			type: String,
			required: true,
		},
	},
	emits: ['assinar-digitalmente'],
	data() {
		return {
			exibirModalConfirmacao: false,
			exibirModalFormulario: false,
			certificados: [],
			assinaturaDigital: null,
			loadingHelper: null,
			httpHeader: {},
		}
	},
	computed: {
		documentosSelecionados() {
			return this.$store.state.modalAssinaturaFlowbee.documentosSelecionados
		},
		tituloDocumento() {
			return this.getTituloDocumento()
		},
	},
	async mounted() {
		await this.inicializarConfiguracoesFlowbee()
		await this.iniciarAssinaturaDigital()
	},
	methods: {
		async assinarDigitalmente(certificadoThumbprint) {
			await this.$emit('assinar-digitalmente', certificadoThumbprint)
		},
		async iniciarAssinaturaDigital() {
			this.setMensagemLoading('Iniciando serviço de assinatura...')

			this.loadingHelper.start()
			const webPki = await this.carregarWebPki()
			this.loadingHelper.stop()

			await this.tratarSeWebPkiInstalledEstiverInstalada(webPki)
		},
		async tratarSeWebPkiInstalledEstiverInstalada(webPki) {
			if (webPki) {
				this.certificados = await this.assinaturaDigital.listCertificates()
				this.abrirModalFormulario()
			} else {
				this.abrirModalConfirmacao()
			}
		},
		async carregarWebPki() {
			return this.assinaturaDigital.loadWebPki()
		},
		confirmarModalExtensaoNaoInstalada() {
			this.assinaturaDigital.redirectToInstallWebPki()
		},
		abrirModalFormulario() {
			this.exibirModalFormulario = true
		},
		fecharModalFormulario() {
			this.exibirModalFormulario = false
		},
		abrirModalConfirmacao() {
			this.exibirModalConfirmacao = true
		},
		fecharModalConfirmacao() {
			this.exibirModalConfirmacao = false
		},
		fechar() {
			this.$emit('fechar-modal')
			this.$emit('fechar-modal-pai')
		},
		async inicializarConfiguracoesFlowbee() {
			this.loadingHelper = new LoadingScreen(this.$store)

			this.httpHeader = this.criarTokenNoHeaderDasRequisicoes()
			this.$store.commit(mutationTypes.LOKI.SET_ACCESS_TOKEN, this.httpHeader)

			const configuracoes = await this.$store.dispatch(actionTypes.FLOWBEE.BUSCAR_CONFIGURACOES, this.httpHeader)
			this.$store.commit(mutationTypes.LOKI.SET_LACUNA_LICENSE, configuracoes.licencaLacuna)
			this.assinaturaDigital = new AzDigitalSignature({ store: this.$store })
		},
		getTituloDocumento() {
			if (!this.ehAcaoEmLote()) {
				return this.documentosSelecionados[0].titulo
			}

			return 'Modal de Assinatura Digital'
		},
		ehAcaoEmLote() {
			return this.documentosSelecionados && this.documentosSelecionados.length > 1
		},
	},
}
</script>
<style lang="stylus" scoped>
.padding-zero
	padding: 0 !important
</style>
